import { logger, saveState } from 'helpers';
import type { AppState } from './appState';

export type Payload = Partial<AppState>;

type Action = [(state: AppState, payload: Payload) => AppState, Payload];

export type Dispatch = React.Dispatch<Action>;

export function reducer(state: AppState, [action, payload]: Action) {
	const newState = action(state, payload);
	logger({ action, payload, state, newState });
	saveState(newState);
	return newState;
}
